<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Inputmask from 'inputmask'

defineProps({
  label: {
    type: String,
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
})

const modelValue = defineModel<number | null>()
const inputRef = ref<HTMLInputElement | null>(null)

onMounted(() => {
  if (inputRef.value) {
    const initialValue = modelValue.value ?? 0
    inputRef.value.value = initialValue.toString().replace('.', ',')

    Inputmask({
      alias: 'numeric',
      groupSeparator: ' ',
      radixPoint: ',',
      digits: 2,
      rightAlign: false,
    }).mask(inputRef.value)
  }
})

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  const cleanedValue = target.value.replace(/\s/g, '').replace(',', '.')

  modelValue.value = isNaN(parseFloat(cleanedValue)) ? null : parseFloat(cleanedValue)
}
</script>

<template>
  <label class="form-control w-full">
    <div class="label" v-if="label">
      <span class="label-text font-semibold">
        {{ label }}
        <span v-if="required" class="text-red-500">*</span>
      </span>
    </div>
    <div class="input input-bordered input-sm flex items-center gap-2">
      <input
        ref="inputRef"
        class="w-full outline-hidden"
        type="text"
        v-model="modelValue"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="handleInput"
      />
      <span class="text-gray-600 font-medium">€</span>
    </div>
  </label>
</template>
